<template>
  <LegalPage>
    <AppContainer>
      <component :is="componentMap[language]" />
    </AppContainer>
  </LegalPage>
</template>

<script setup lang="ts">
import { LazyPrivacyEn, LazyPrivacySv, LazyPrivacyHe, LazyPrivacyRu } from '#components';
import { localeToLanguage } from '~/helpers/format';
import type { Language } from '~/types';

const { locale, tt } = useLocalization();
const language = localeToLanguage(locale.value);
usePageHead({
  title: tt('privacy_page.title'),
  description: tt('privacy_page.meta_desc'),
  image: {
    src: '/images/desk.webp',
    width: 496,
    height: 750,
    alt: tt('contact_page.desk')
  },
  alternateBranches: 'all',
});
const componentMap: Record<Language, Component> = {
  he: LazyPrivacyHe,
  en: LazyPrivacyEn,
  sv: LazyPrivacySv,
  ru: LazyPrivacyRu
};
</script>